import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

type SignatureCanvasRef = SignatureCanvas & {
  getCanvas(): HTMLCanvasElement;
};

type SignatureBasicPadProps = {
  signData?: string;
  setSignData: React.Dispatch<React.SetStateAction<string>>;
};

const SignatureBasicPad: React.FC<SignatureBasicPadProps> = ({
  signData,
  setSignData,
}) => {
  const sigCanvas = useRef<SignatureCanvasRef | null>(null);
  const [viewSignWriter, setViewSignWriter] = useState<boolean>(false);

  const clear = () => {
    sigCanvas.current?.clear();
    setSignData('');
  };

  const save = () => {
    if (!sigCanvas.current) return;

    const canvas = sigCanvas.current.getCanvas();
    const dataUrl = canvas.toDataURL("image/png");

    setSignData(dataUrl);
    setViewSignWriter(false); 
  };

  const close = () => {
    setViewSignWriter(false);
  };

  return (
    <div className="canvas-sign-basic">
      {/* Main Display */}
      <div className="canvas-sign-basic-base" onClick={() => setViewSignWriter(true)}>
        {signData ? (
          <div className="canvas-sign-data">
            <img src={signData} alt="Signature" />
          </div>
        ) : (
          <div className="sign-basic-placeholder">&nbsp;</div>
        )}
      </div>

      {/* Popup Writer */}
      {viewSignWriter && (
        <div className="canvas-sign-frame">
          <div className="canvas-sign-control">
            <button type="button" onClick={save}>Add Signature</button>
            <button type="button" onClick={clear}>Clear</button>
            <button type="button" onClick={close}>X</button>
          </div>

          <SignatureCanvas
            ref={sigCanvas}
            penColor="black"
            canvasProps={{ width: 380, height: 200, className: "canvas-sign-writer" }}
          />
        </div>
      )}
    </div>
  );
};

export default SignatureBasicPad;